/* ==========================================================================
   WHOVIX 3D engine
   Pointer-tracked tilt, hero depth parallax, 3D scroll entrances.
   rAF-throttled, writes only CSS custom properties. No-ops on touch and
   on prefers-reduced-motion.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__whovix3d) return;
  window.__whovix3d = true;

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarse = window.matchMedia && window.matchMedia('(hover: none)').matches;
  var off = reduced || coarse;

  var MAX_TILT = 9;

  var CARDS = [
    ['.whovix-product-card', '.whovix-product-card__img'],
    ['.card-wrapper', '.card__media'],
    ['.wx-rev__card', 'blockquote'],
    ['.wx-trust__item', null]
  ];

  function prepare(root) {
    CARDS.forEach(function (pair) {
      Array.prototype.forEach.call(root.querySelectorAll(pair[0]), function (card) {
        if (card.hasAttribute('data-wx-tilt')) return;
        card.setAttribute('data-wx-tilt', '');

        if (off) return;

        if (pair[1]) {
          var pop = card.querySelector(pair[1]);
          if (pop) pop.classList.add('wx-3d-pop');
        }

        if (!card.querySelector('.wx-3d-glare')) {
          var glare = document.createElement('span');
          glare.className = 'wx-3d-glare';
          glare.setAttribute('aria-hidden', 'true');
          card.appendChild(glare);
        }
      });
    });

    ['.whovix-collection__grid', '.whovix-featured__grid', '.product-grid', '.wx-trust__grid'].forEach(
      function (sel) {
        Array.prototype.forEach.call(root.querySelectorAll(sel), function (el) {
          el.classList.add('wx-3d-scene');
        });
      }
    );

    Array.prototype.forEach.call(root.querySelectorAll('.wx-marquee'), function (el) {
      el.classList.add('wx-3d-band');
    });

    Array.prototype.forEach.call(root.querySelectorAll('.hero-slider, .wx-hero'), function (el) {
      el.classList.add('wx-3d-hero');
      if (!off) bindHero(el);
    });

    if (!reduced) {
      Array.prototype.forEach.call(
        root.querySelectorAll('.whovix-product-card[data-wx-reveal="up"]'),
        function (el) { el.setAttribute('data-wx-reveal', 'deck'); }
      );
      Array.prototype.forEach.call(
        root.querySelectorAll('.whovix-editorial__media[data-wx-reveal]'),
        function (el) { el.setAttribute('data-wx-reveal', 'swing'); }
      );
    }
  }

  /* Tilt - one delegated pointer listener, rAF-batched */

  var active = null;
  var pending = null;
  var frame = false;

  function apply() {
    frame = false;
    if (!active || !pending) return;

    var rect = active.__wxRect;
    if (!rect || !rect.width || !rect.height) return;

    var x = (pending.x - rect.left) / rect.width;
    var y = (pending.y - rect.top) / rect.height;

    active.style.setProperty('--ry', ((x - 0.5) * 2 * MAX_TILT).toFixed(2) + 'deg');
    active.style.setProperty('--rx', ((0.5 - y) * 2 * MAX_TILT).toFixed(2) + 'deg');
    active.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
    active.style.setProperty('--my', (y * 100).toFixed(1) + '%');
  }

  function release(card) {
    card.classList.remove('is-tilting');
    card.style.setProperty('--rx', '0deg');
    card.style.setProperty('--ry', '0deg');
    card.__wxRect = null;
  }

  function onMove(event) {
    var card = event.target && event.target.closest
      ? event.target.closest('[data-wx-tilt]')
      : null;

    if (card !== active) {
      if (active) release(active);
      active = card;
      if (active) {
        active.__wxRect = active.getBoundingClientRect();
        active.classList.add('is-tilting');
      }
    }

    if (!active) return;

    pending = { x: event.clientX, y: event.clientY };
    if (!frame) {
      frame = true;
      requestAnimationFrame(apply);
    }
  }

  /* Hero depth parallax */

  function bindHero(hero) {
    if (hero.__wxHeroBound) return;
    hero.__wxHeroBound = true;

    var ticking = false;
    var last = null;

    function update() {
      ticking = false;
      if (!last) return;
      var rect = hero.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var px = (last.x - rect.left) / rect.width - 0.5;
      var py = (last.y - rect.top) / rect.height - 0.5;
      hero.style.setProperty('--px', px.toFixed(3));
      hero.style.setProperty('--py', py.toFixed(3));
    }

    hero.addEventListener(
      'pointermove',
      function (event) {
        last = { x: event.clientX, y: event.clientY };
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );

    hero.addEventListener('pointerleave', function () {
      hero.style.setProperty('--px', '0');
      hero.style.setProperty('--py', '0');
    });
  }

  /* Boot */

  function init(root) {
    prepare(root || document);
    if (typeof window.whovixMotionInit === 'function') {
      window.whovixMotionInit(root || document);
    }
  }

  if (!off) {
    document.addEventListener('pointermove', onMove, { passive: true });
    document.addEventListener('pointerleave', function () {
      if (active) release(active);
      active = null;
    });
    window.addEventListener(
      'scroll',
      function () {
        if (active) active.__wxRect = active.getBoundingClientRect();
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  window.whovix3dInit = init;
})();
